import BaseInsuranceCardAdapter from './base-insurance-card-adapter';

export default class PhotoId extends BaseInsuranceCardAdapter {
  getData(record) {
    return {
      contactInfoRequestConnectionsId: record.belongsTo('connection')?.id,
    };
  }
}
